/**
 * News menu component
 */

import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Menu from "./menu";

const MenuNews = ({ location }) => {
  const data = useStaticQuery(graphql`
    {
      allMenuItems(
        filter: { menu_name: { eq: "news" }, parent: { id: { eq: null } } }
        sort: {order: DESC, fields: weight}
      ) {
        nodes {
          url
          childrenMenuItems {
            url
            childrenMenuItems {
              url
              title
            }
            title
          }
          title
        }
      }
    }
  `);
  return <Menu data={data} location={location} />;
};

export default MenuNews;
